/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Terms_YetInputs */



/**
* | output |
* | --- |
* | "No terms yet. Click the + button to add your first term." |
*
* @param {Knp_Lookup_No_Terms_YetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_terms_yet = /** @type {((inputs?: Knp_Lookup_No_Terms_YetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Terms_YetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun terme pour l'instant. Cliquez sur le bouton + pour ajouter votre premier terme.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Begriffe hinterlegt. Klicken Sie auf die Schaltfläche „+“, um Ihren ersten Begriff hinzuzufügen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun termine ancora. Clicca sul pulsante + per aggiungere il tuo primo termine.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сроки полномочий пока отсутствуют. Нажмите кнопку «+», чтобы добавить свой первый срок.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay términos. Haz clic en el botón + para agregar el primer término.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无条款。点击“+”按钮添加您的第一个条款。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("まだ用語がありません。最初の用語を追加するには、「+」ボタンをクリックしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई टर्म नहीं है। अपना पहला टर्म जोड़ने के लिए + बटन पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda não há termos. Clique no botão + para adicionar seu primeiro termo.")
	return /** @type {LocalizedString} */ ("No terms yet. Click the + button to add your first term.")
});